import { SummaryStat } from "components/common/summaryStat";
import { useTenantTranslation, useUnitsFormatter } from "hooks/formatters";
import { HeatsSummaryItem as HeatsSummaryItemType } from "src/store/api/generatedApi";

interface HeatsSummaryStatItemProps {
  item: HeatsSummaryItemType;
}

/**
 * Renders a single daily summary statistic
 */
export const HeatsSummaryStatItem = ({ item }: HeatsSummaryStatItemProps) => {
  const { t } = useTenantTranslation();
  const units = useUnitsFormatter(false);

  const labelKey = item.summary_name;
  const tooltipKey = `${item.summary_name}Tooltip`;

  const labelOverride =
    item.summary_name === "specificCost" ||
    item.summary_name === "specificCostBillet"
      ? t(
          item.summary_name === "specificCostBillet"
            ? "averageSpecificCostBillet"
            : "averageSpecificCost",
          { unit: units("specific_cost", false) }
        )
      : t(labelKey);

  const statValue = typeof item.value === "number" ? item.value : null;

  return (
    <SummaryStat
      key={item.summary_name}
      label={labelKey}
      value={statValue}
      decimalPlaces={item.decimal_places}
      units={item.unit_type ?? null}
      hideDivider
      labelOverride={labelOverride}
      tooltip={t(tooltipKey)}
    />
  );
};
